import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Image, accentColors, secondaryColors } from '@tryhackme/thm-ui-components';

export const StyledCheckIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.colors.success.main};
  font-weight: bold;
`;

export const StyledText = styled.p<{ mb?: string }>`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-bottom: ${({ mb = '3rem' }) => mb};
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
`;

export const StyledCopyTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
  margin-bottom: 3rem;
`;

export const StyledPlaceholder = styled.div<{ $isDarkMode: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow: hidden;
  width: 100%;
  height: 3.6rem;
  background-color: ${({ theme, $isDarkMode }) =>
    $isDarkMode ? theme.colors.background.dark : theme.colors.background.main};
  border: 0.1rem solid ${({ theme }) => theme.colors.border.light};
  border-radius: 0.5rem 0 0 0.5rem;
`;

export const StyledCopyText = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.text.lighter};
  padding: 1.3rem 0.9rem;

  max-width: 100%; /* Ensures that the text can't grow larger than its container */
  white-space: nowrap; /* Text won't wrap to next line */
  overflow: hidden; /* Hide overflow */
  text-overflow: ellipsis; /* Show ellipsis when overflow */
`;

export const StyledCopyButton = styled.button<{ $isDarkMode: boolean }>`
  height: 3.6rem;
  width: 8.1rem;
  background-color: ${({ theme, $isDarkMode }) => ($isDarkMode ? accentColors.info.light : theme.colors.info.main)};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  color: ${({ theme }) => theme.colors.white};
  border-radius: 0 0.4rem 0.4rem 0;
  padding: 1rem 1.6rem;
  outline: none;
`;

export const StyledModuleCardWrapper = styled.div<{ $isDarkMode: boolean }>`
  margin-bottom: 3rem;
  padding: 1.6rem;
  border-radius: 0.5rem;
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  background-color: ${({ theme, $isDarkMode }) =>
    $isDarkMode ? secondaryColors.secondary.light : theme.colors.background.main};
`;

export const StyledModuleDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledImage = styled(Image)`
  width: 10.5rem;
`;

export const StyledTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  margin-bottom: 0.9rem;
`;

export const StyledDescription = styled.p<{ $isDarkMode: boolean }>`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme, $isDarkMode }) => ($isDarkMode ? theme.colors.grey[200] : theme.colors.grey[900])};
  margin-bottom: 1.7rem;
`;

export const StyledAnchor = styled.a<{ $isDarkMode: boolean }>`
  color: ${({ theme }) => theme.colors.info};
  text-decoration: none;
  display: block;
  width: 100%;
  text-align: right;
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  padding-top: 1rem;
  border-top: 0.1rem solid
    ${({ theme, $isDarkMode }) => ($isDarkMode ? secondaryColors.secondary.lighter : theme.colors.grey[300])};
  margin-top: 1.6rem;

  &:hover {
    text-decoration: underline;
    transition: text-decoration 0.2s ease-in-out;
  }
`;

export const StyledLinkIcon = styled(FontAwesomeIcon)`
  margin-left: 0.6rem;
  color: ${({ theme }) => theme.colors.info};
  font-weight: bold;
`;
